import { TextField } from "@mui/material";

function EmailBox({ setLoginEmail }) {
  return (
    <TextField
      id="custom-email"
      data-testid="contact-user-email"
      label="Email"
      style={{ width: "100%" }}
      onChange={(input) => {
        console.log(input.target.value);
        setLoginEmail(input.target.value);
      }}
    />
  );
}

export default EmailBox;
